import { FC } from "react";
import styles from "./SearchInput.module.css";

type Props = {
  value: string;
  onChange: (value: string) => void;
  onClear: () => void;
};

export const SearchInput: FC<Props> = ({ value, onChange, onClear }) => {
  return (
    <div className={styles.searchWrapper}>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Search..."
        className={styles.search}
      />

      {value && (
        <button onClick={onClear} className={styles.clearBtn}>
          ✕
        </button>
      )}
    </div>
  );
};
